import vuex from "src/vuex"
import router from "src/http/router";
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";
import userPermission from "src/util/valueObjects/userPermission";



export default (to, from, next) => {
  let permissions = vuex.getters.getPermissions;
  let hasModule = false;
  for (let permission of permissions) {
    let module = userPermission.ALL_MODULES.QUOTATION.value;
    if (permission.search(module+"__") !== -1) {
      hasModule = true;
    }
  }
  if(hasModule === false){
    vuex.dispatch("redirectToMainMenu");
  }

  next();
};
